export default "__VITE_ASSET__CXYnKqwh__"